<template>
  <div>
    <v-btn
      color="primary"
      :class="{
        'mb-2': $vuetify.breakpoint.xsOnly && fields.length,
      }"
      class="mb-4"
      :block="$vuetify.breakpoint.xsOnly"
      small
      @click="showFieldModal('create')"
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      {{ $t('Add input field') }}
    </v-btn>

    <contact-form-fields-list
      :fields="fields"
      @move-field-up="handleMoveFieldUp"
      @move-field-down="handleMoveFieldDown"
      @edit-field="(field, index) => showFieldModal('edit', field, index)"
      @delete-field="handleDeleteField"
    />

    <contact-form-field-edit-or-create-dialog
      :faq-id="faqId"
      :title="dialogTitle"
      :mode="fieldDialog.mode"
      :value="fieldDialog.show"
      :fields="fields"
      :field-id="fieldDialog.fieldId"
      :field-types="fieldTypes"
      @input="value => fieldDialog.show = value"
      @refresh-preview="handleRefreshPreview"
    />
  </div>
</template>

<script>
import clone from 'lodash/clone';
import ContactFormFieldEditOrCreateDialog from '@/components/faq/ContactFormFieldEditOrCreateDialog';
import ContactFormFieldsList from '@/components/faq/ContactFormFieldsList';

export default {
  components: {
    ContactFormFieldsList,
    ContactFormFieldEditOrCreateDialog,
  },

  props: {
    faqId: {
      type: Number,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    fieldTypes: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      fieldDialog: {
        mode: null,
        fieldId: null,
        show: false,
      },
    }
  },

  computed: {
    dialogTitle() {
      switch (this.fieldDialog.mode) {
        case 'create':
          return this.$t('Add input field');

        case 'edit':
          return this.$t('Edit input field');

        default:
          return '';
      }
    }
  },

  watch: {
    'fieldDialog.show': function (value) {
      if (value === true) return;

      for (const key in this.fieldDialog) {
        this.fieldDialog[key] = null;
      }
    }
  },

  methods: {
    handleRefreshPreview() {
      this.$root.refreshFaqPreview();
    },

    showFieldModal(mode, field) {
      if (mode === 'edit') {
        this.fieldDialog.fieldId = field.id;
      }

      this.fieldDialog.show = true;
      this.fieldDialog.mode = mode;
    },

    handleMoveFieldUp(field, index) {
      const fields = clone(this.fields);
      const toIdx = index === 0 ? fields.length : index - 1;
      fields.splice(toIdx, 0, fields.splice(index, 1)[0]);

      const order = fields.map(cat => cat.id);

      const url = this.route('faq.contact-field.sort-order.update', [this.faqId]);
      this.$inertia.patch(url, { order }, {
        preserveScroll: true,
        onSuccess: () => {
            this.handleRefreshPreview();
          }
      });
    },

    handleMoveFieldDown(field, index) {
      const fields = clone(this.fields);
      const toIdx = index === fields.length - 1 ? 0 : index + 1;
      fields.splice(toIdx, 0, fields.splice(index, 1)[0]);

      const order = fields.map(cat => cat.id);

      const url = this.route('faq.contact-field.sort-order.update', [this.faqId]);
      this.$inertia.patch(url, { order }, {
        preserveScroll: true,
        onSuccess: () => {
            this.handleRefreshPreview();
          }
      });
    },

    async handleDeleteField(field) {
      const confirmed = await this.$root.$confirm(
        this.$t('Delete input field'),
        this.$t("Are you sure you want to delete the input field '{field}'?", {
          field: field.default_translation.label
        })
      );

      if (confirmed) {
        const url = this.route('faq.contact-field.destroy', [this.faqId, field.id]);
        this.$inertia.delete(url, {
          onSuccess: () => {
            this.handleRefreshPreview();
          }
        });
      }
    }
  }
}
</script>